import React, { PureComponent } from 'react'

import { Icon, FlexContainer } from 'components'

import './hint.scss'

class Hint extends PureComponent {
	onRemove = () => {
		const { editor, node } = this.props

		editor.removeNodeByKey(node.key)
	}

	onChangeTheme = theme => {
		const { editor, node } = this.props

		editor.setNodeByKey(node.key, {
			type: 'hint',
			data: {
				theme,
			},
		})
	}

	render() {
		const {
			attributes,
			children,
			node: { data },
		} = this.props

		const currentTheme = data.get('theme') || 'info'

		return (
			<div
				{...attributes}
				className={`c-hint c-hint--theme-${currentTheme} ${attributes.className}`}
			>
				<FlexContainer
					alignItems="flex-start"
					justifyContent="flex-start"
				>
					<div className="c-hint__icon">
						<Icon name={currentTheme} />
					</div>
					<div className="c-hint__content">{children}</div>
				</FlexContainer>
			</div>
		)
	}
}

export default Hint
